import { createSlice } from "@reduxjs/toolkit";

interface MapState {
    initialized: boolean;
}

const initialMapState: MapState = {
    initialized: !!window.google?.maps,
};

// Due to the fact google maps may load before or after our application loads
// we need to store in global state whether maps is loaded or not.
// The actual initialization logic is handled in the Map component
export const googleMapSlice = createSlice({
    name: "googleMap",
    initialState: initialMapState,
    reducers: {
        initializeMaps: (state) => {
            state.initialized = true;
        },
    },
});

export const { initializeMaps } = googleMapSlice.actions;
export default googleMapSlice.reducer;
